<template>
    <div class="col-lg-12">
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">{{ cardTitle }}</h4>
                <b-alert v-show="alertShow" show dismissible :variant="alertVariant">{{
                alertMsg
                }}</b-alert>
                <p class="card-title-desc">
                    {{ description }}
                </p>
                <form class="needs-validation" @submit.prevent="UpdateFormSubmit(holidayObject.id)">
                    <div class="row">
                        <div class="col-md-6">
                        <div class="mb-3">
                            <label for="validationCustom01">Σχόλια</label>
                            <b-form-input
                            id="validationCustom01"
                            type="text"
                            class="form-control"
                            placeholder="Σχόλια"
                            v-model="holiday.holidayComments"
                            />
                        </div>
                        <div class="mb-3">
                            <label class="mt-3">Τύπος Άδειας*</label>
                            <multiselect
                            required
                            id="validationCustom02"
                            v-model="holiday.holidayTypeValue"
                            :disabled="new Date()>=new Date(holiday.startDate)"
                            :options="holidayTypesOptions"
                            placeholder="Επιλέξτε Τύπο"
                            selectLabel="Eπιλογή Τύπο"
                            selectedLabel="Επιλέχθηκε"
                            deselectLabel="Αποεπιλογή"
                            ></multiselect>
                        </div>
                        </div>
                        <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-12">
                            <div class="mb-3">
                                <label class="mt-3">Από*</label>
                                <b-form-input
                                id="validationCustom03"
                                v-model="holiday.startDate"
                                :readonly="new Date()>=new Date(holiday.startDate)"
                                type="date"
                                placeholder="DD-MM-YYYY"
                                format="DD-MM-YYYY"
                                autocomplete="off"
                                ></b-form-input>
                            </div>
                            </div>
                            <div class="col-md-12">
                            <div class="mb-3">
                                <label class="mt-3">Μέχρι*</label>
                                <b-form-input
                                id="validationCustom04"
                                v-model="holiday.endDate"
                                type="date"
                                placeholder="DD-MM-YYYY"
                                format="DD-MM-YYYY"
                                autocomplete="off"
                                ></b-form-input>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    <button class="btn btn-primary" type="submit">
                        Ολοκλήρωση
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import session from "../../../../api/session";
import Multiselect from "vue-multiselect";
export default {
  components: {
    Multiselect,
  },
  props: {
    cardTitle: String,
    description: String,
    holidayObject: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      holiday: {
        startDate: this.holidayObject.holidays_start_date,
        endDate: this.holidayObject.holidays_end_date,
        holidayTypes: [],
        holidayTypeValue: this.holidayObject.holiday_type_name,
        holidayComments: this.holidayObject.comments,
      },
      alertShow: false,
      alertVariant: "",
      alertMsg: ""
    };
  },
  mounted() {
    this.fetchHolidayTypes();
  },
  computed: {
    holidayTypesOptions() {
      return this.holiday.holidayTypes.map((e) => e.title);
    },
  },
  methods: {
    fetchHolidayTypes() {
      session.get("api/holidays/holiday-type-list/").then((resp) => {
        this.holiday.holidayTypes = resp.data;
      });
    },
    UpdateFormSubmit(holidayID) {
      if (!this.holiday.holidayTypeValue) {
          alert('Παρακαλώ επιλέξτε έναν τύπο άδειας.');
          return;
      }
      if (!this.holiday.startDate || !this.holiday.endDate) {
          alert('Παρακαλώ συμπληρώστε ημερομηνίες');
          return;
      }
      if (this.holiday.startDate>this.holiday.endDate) {
          alert('Η ημερομηνία λήξης πρέπει να είναι μετά την ημερομηνία έναρξης');
          return;
      }
      
      const holidayTypesId = this.holiday.holidayTypes
          .filter((e) => e.title === this.holiday.holidayTypeValue)
          .map((item) => item.id)[0];
      session
          .put(`api/person/holiday/${holidayID}/actions/`, {
              holidays_start_date: this.holiday.startDate,
              holidays_end_date: this.holiday.endDate,
              comments: this.holiday.holidayComments,
              person: this.$route.params.id,
              holiday_type: holidayTypesId
          })
          .then(() => {
              this.alertShow = !this.alertShow;
              this.alertVariant = "success";
              this.alertMsg = 'Τα δεδομένα ενημερώθηκαν επιτυχώς';
              setTimeout(() => {
                  this.$bvModal.hide(`Rel${holidayID}`);
                  this.$emit("holidayUpdated");
              }, 1500);
          })
          .catch((e) => {
              this.alertShow = !this.alertShow;
              this.alertVariant = "danger";
              this.alertMsg = e.response.data;
          });
 },
}
}
</script>